import { render } from "./SORecomDetail.vue?vue&type=template&id=ff8eccd2"
import script from "./SORecomDetail.ts?vue&type=script&lang=ts"
export * from "./SORecomDetail.ts?vue&type=script&lang=ts"

import "./SORecomDetail.vue?vue&type=style&index=0&id=ff8eccd2&lang=css"
script.render = render

export default script